import type { RetentionUnitEnum } from 'config/api/processingActivities/processingActivities.types';

export type ProcessingActivityLegalBasis = 'gdpr_6_1_a' | 'gdpr_6_1_b' | 'gdpr_6_1_c' | 'gdpr_6_1_d' | 'gdpr_6_1_e' | 'gdpr_6_1_f';

export type ProcessingActivityEditorCategory = {
  id?: number;
  name: string;
};

export type ProcessingActivityEditorPurpose = {
  clientId: string;
  id?: number;
  purposeText: string;
  legalBasis: ProcessingActivityLegalBasis | '';
  legalBasisComment: string;
  retentionTrigger: string;
  retentionValue: number | null;
  retentionUnit: RetentionUnitEnum | '';
  retentionComment: string;
  sortOrder: number;
  isSoftDeleted: boolean;
};

export type ProcessingActivityEditorFormValues = {
  name: string;
  description: string;
  processingRole: 'controller' | 'processor' | '';
  dataSubjectCategories: ProcessingActivityEditorCategory[];
  personalDataCategories: ProcessingActivityEditorCategory[];
  recipientCategories: ProcessingActivityEditorCategory[];
  minimumSecurityMeasures: string;
  purposes: ProcessingActivityEditorPurpose[];
};

export type ProcessingPurposePayloadDTO = {
  id?: number;
  purpose_text?: string;
  legal_basis?: string;
  legal_basis_comment?: string;
  lia_required?: boolean;
  retention_trigger?: string;
  retention_value?: number | null;
  retention_unit?: RetentionUnitEnum | '' | null;
  retention_description?: string;
  retention_comment?: string;
  sort_order?: number;
  is_deleted?: boolean;
};

export type ProcessingActivityCategoryPayloadDTO = {
  id?: number;
  name: string;
};

export const EMPTY_PROCESSING_ACTIVITY_EDITOR_FORM: ProcessingActivityEditorFormValues = {
  name: '',
  description: '',
  processingRole: '',
  dataSubjectCategories: [],
  personalDataCategories: [],
  recipientCategories: [],
  minimumSecurityMeasures: '',
  purposes: [],
};
